import { createSlice } from "@reduxjs/toolkit";
import {
  authInitialState,
  ccb14InitialState,
  logoutModalInitialState,
  contractPDFsInitialState,
  additionalInfoPageInitialState,
} from "../state";
import {
  setCCBCandidateId,
  getCCBdata,
  setChecked,
  setIsBack,
  updateCCBdata,
  insertCCBdata,
} from "../reducers/ccb14";
import { setAuthenticators } from "../reducers/auth";
import { setShowLogoutModal } from "../reducers/logout";
import {
  setAdditionalInfo,
  setCoveredAdvisorCertificate,
} from "../reducers/additionalnfo";

import {
  setContractPdfUrl,
  setDisclosurePdfUrl,
  setMMLISAddOnPdfUrl,
  setIAAddOnPdfUrl,
  setHistoricalConfPdfUrl,
  setAddOnStatuses,
} from "../reducers/contractpdf";

export const authSlice = createSlice({
  name: "authenticators",
  initialState: authInitialState,
  reducers: {
    setAuthenticators,
  },
});

export const contractPDFSlice = createSlice({
  name: "contracts",
  initialState: contractPDFsInitialState,
  reducers: {
    setContractPdfUrl,
    setDisclosurePdfUrl,
    setMMLISAddOnPdfUrl,
    setIAAddOnPdfUrl,
    setHistoricalConfPdfUrl,
    setAddOnStatuses,
  },
});

export const logoutSlice = createSlice({
  name: "logout",
  initialState: logoutModalInitialState,
  reducers: {
    setShowLogoutModal,
  },
});

export const ccb14Slice = createSlice({
  name: "ccb14",
  initialState: ccb14InitialState,
  reducers: {
    setCCBCandidateId,
    setChecked,
    setIsBack,
  },
  extraReducers: (builder) => {
    getCCBdata(builder);
    updateCCBdata(builder);
    insertCCBdata(builder);
  },
});

export const additionalInfoSlice = createSlice({
  name: "additionalInfo",
  initialState: additionalInfoPageInitialState,
  reducers: {
    setAdditionalInfo,
    setCoveredAdvisorCertificate,
  },
});
